import BaseResource from './index'
import UserResource from './user'
import MarketResource from './market'
import ImageResource from './image'
import ListingResource from './listing'

export default class CompanyResource extends BaseResource {
    static endpoint = '/companies'

    static related() {
        return {
            owner: UserResource,
            market: MarketResource,
            image: ImageResource,
        }
    }

    static sizeOptions = {
        '0': 'Not Sure',
        '10': '1-10',
        '50': '11-50',
        '200': '51-200',
        '500': '201-500',
        '1000': '500-1000',
        '1001': '>1000',
    }

    async listings(filters = {}) {
        return await ListingResource.filter(Object.assign({ company: this.id, ordering: '-created' }, filters))
    }

    async listingsAll(filters = {}) {
        return await ListingResource.filterAll(Object.assign({ company: this.id, ordering: '-created' }, filters))
    }

    canCreateListing() {
        return (this.attributes.tier > 0 || this.attributes.prepaid_listings > 0) && this.attributes.in_good_standing
    }

    canViewDevelopers() {
        return this.attributes.tier > 0 && this.attributes.in_good_standing
    }

    async getDefaultPaymentMethod() {
        let paymentAction = this.wrap('/payment')
        let paymentResult = await paymentAction.get()
        if (paymentResult.status === 200) {
            return paymentResult.data
        }

        return false
    }

    async addDefaultPaymentMethod(token) {
        let paymentAction = this.wrap('/payment')
        let paymentResult = await paymentAction.post({ token })
        if (~[200, 201].indexOf(paymentResult.status)) {
            return paymentResult.data
        }

        throw new Error('Failed to add default payment method')
    }

    async subscribeToTeams() {
        let action = this.wrap('/subscribe/teams')
        await action.post()
        return true
    }

    async subscribeToUnlimited() {
        let action = this.wrap('/subscribe/unlimited')
        await action.post()
        return true
    }

    async prepayListing() {
        let action = this.wrap('/prepay')
        await action.post()
        return true
    }
}
